module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('drag', {
    attrs: {
      "transfer-data": {
        example: 'minimal'
      }
    }
  }, [_vm._v("drag")]), _vm._v(" "), _c('drop', {
    on: {
      "drop": _vm.handleDrop
    }
  }, [_vm._v("drop")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aca1de5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Minimal.vue
// module id = 43
// module chunks = 0